import { render, staticRenderFns } from "./ImportStudent.vue?vue&type=template&id=14db45a0&scoped=true&"
import script from "./ImportStudent.vue?vue&type=script&lang=js&"
export * from "./ImportStudent.vue?vue&type=script&lang=js&"
import style0 from "./ImportStudent.vue?vue&type=style&index=0&id=14db45a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db45a0",
  null
  
)

export default component.exports